import { render, staticRenderFns } from "./SettingsPeriodModal.vue?vue&type=template&id=164ae9cc&lang=pug&"
import script from "./SettingsPeriodModal.vue?vue&type=script&lang=js&"
export * from "./SettingsPeriodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports